import React, { useEffect } from 'react';

const SalesPOI = () => {
  // Tambahkan useEffect atau handler untuk menangkap error Google Maps
  useEffect(() => {
    // Error handler untuk Google Maps API
    window.gm_authFailure = () => {
      alert('API Key tidak valid atau tidak diizinkan untuk domain ini. Silakan hubungi administrator.');
      window.location.href = '/unauthorized';
    };
    
    return () => {
      delete window.gm_authFailure;
    };
  }, []);

  return (
    <div>
      <h1>Sales Point of Interest</h1>
      {/* Konten dan logika untuk komponen SalesPOI */}
    </div>
  );
};

export default SalesPOI;